import { useState } from "react";
import { debounce } from "lodash-es";
import { MediaConstraints } from "types";

const useController = (
  constraints?: MediaConstraints | null,
  onChangeConstraints?: (constraints: MediaConstraints) => void
) => {
  const [facingMode, setFacingMode] = useState<"user" | "environment" | string>(
    constraints && typeof constraints.video === "object" && typeof constraints.video.facingMode === "string"
      ? constraints.video.facingMode
      : "user" ?? "user"
  );

  const debounceTime = 200;

  const onSwitchCam = debounce(async () => {
    if (!onChangeConstraints) return;
    const mode = facingMode === "user" ? "environment" : "user";
    const constraints: MediaConstraints = {
      video: {
        facingMode: mode,
      },
    };
    await onChangeConstraints(constraints);
    setFacingMode(mode);
  }, debounceTime);

  const onToggleCam = debounce(async () => {
    if (!onChangeConstraints || !constraints) return;
    onChangeConstraints({ videoEnabled: !constraints.videoEnabled });
  }, debounceTime);

  const onToggleMic = debounce(async () => {
    if (!onChangeConstraints || !constraints) return;
    onChangeConstraints({ audioEnabled: !constraints.audioEnabled });
  }, debounceTime);

  const onToggleScreenSharing = debounce(async () => {
    if (!onChangeConstraints || !constraints) return;
    onChangeConstraints({ shareEnabled: !constraints.shareEnabled });
  }, debounceTime);

  const onToggleBlur = debounce(async () => {
    if (!onChangeConstraints || !constraints) return;
    onChangeConstraints({ blurEnabled: !constraints.blurEnabled });
  }, debounceTime);

  return {
    onSwitchCam,
    onToggleCam,
    onToggleMic,
    onToggleScreenSharing,
    onToggleBlur,
  };
};

export default useController;
